import { render } from "./SelectSizeM.vue?vue&type=template&id=232fe260"
import script from "./SelectSizeM.vue?vue&type=script&lang=js"
export * from "./SelectSizeM.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SelectSizeM.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "232fe260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('232fe260', __exports__)) {
    api.reload('232fe260', __exports__)
  }
  
  module.hot.accept("./SelectSizeM.vue?vue&type=template&id=232fe260", () => {
    api.rerender('232fe260', render)
  })

}


export default __exports__